import script from "./allMoviesSeries.vue?vue&type=script&lang=ts&setup=true"
export * from "./allMoviesSeries.vue?vue&type=script&lang=ts&setup=true"

import "./allMoviesSeries.vue?vue&type=style&index=0&id=1e5e73d2&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5e73d2"]])

export default __exports__